import { render } from "./toggleIcon.vue?vue&type=template&id=4e2c8a90&scoped=true"
import script from "./toggleIcon.vue?vue&type=script&lang=js"
export * from "./toggleIcon.vue?vue&type=script&lang=js"

import "./toggleIcon.vue?vue&type=style&index=0&id=4e2c8a90&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4e2c8a90"

export default script